import React, { useState, useContext } from 'react';

const LanguageContext = React.createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('telugu'); // default
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

export default LanguageContext;
